import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, IconButton, Button } from '@material-ui/core';
import { CloseIcon } from '../../../../components/Icon';

const useStyles = makeStyles((theme) => ({
  root: {},
  dia: {
    '& .MuiPaper-root': {
      width: '43.75rem',
      backgroundColor: theme.palette.font.white,
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.125rem 1.3125rem rgba(30, 56, 140, 0.18)',
      margin: '0',
    },
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 'none',
    },
  },
  dialog: {
    height: '21.188rem',
    width: '43.75rem',
    padding: '2.375rem 1.563rem 2.375rem 1.563rem',
  },
  head: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '2.313rem',
    alignItems: 'center',
  },
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    lineHeight: '1.875rem',
    letterSpacing: '0',
    color: theme.palette.font.main,
    fontWeight: 'bold',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: theme.palette.primary.main,
  },
  body: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.25rem',
    lineHeight: '1.875rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    marginBottom: '5.5rem',
  },
  foot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cancel: {
    textTransform: 'capitalize',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.primary.main,
    fontWeight: '500',
    borderRadius: '0.625rem',
    border: '0.12rem solid #538fff',
    width: '12.5rem',
    height: '3rem',
    marginRight: '1rem',
  },
  confirm: {
    textTransform: 'capitalize',
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.5rem',
    backgroundColor: '#4c93ff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.white,
    fontWeight: '500',
    '&:hover': {
      backgroundColor: '#4c93ff',
    },
  },
}));

export default function DiaLog({ dialog, handleDialogClose, handleConfirm, head, body, cancel, confirm }) {
  const classes = useStyles();
  return (
    <Dialog className={classes.dia} open={dialog} onClose={handleDialogClose} aria-labelledby="responsive-dialog-title">
      <div className={classes.dialog}>
        <div className={classes.head}>
          <div className={classes.title}>{head}</div>
          <IconButton id="dialog_1" onClick={handleDialogClose} className={classes.closeIcon}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={classes.body}>{body}</div>
        <div className={classes.foot}>
          <Button id="dialog_2" className={classes.cancel} onClick={handleDialogClose}>
            {cancel}
          </Button>
          <Button id="dialog_3" className={classes.confirm} onClick={handleConfirm}>
            {confirm}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
